export default __webpack_public_path__ + "static/media/logoSodiaIseoWhite.faf1b45c.png";